<template>
<div>

	<div class="modal fade" tabindex="-1" role="dialog" id="punchModal">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
				<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
				<h4 class="modal-title">Bekräfta behandling för:</h4>
			</div>
			<div class="modal-body">
				<p><b>Namn:</b> {{ response.customerName }}<br><b>Längd på behandling:</b> {{ response.treatmentLength }} minuter</p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" v-on:click="submit('confirm')">Bekräfta</button>
			</div>
			</div><!-- /.modal-content -->
		</div><!-- /.modal-dialog -->
	</div>

	<div class="panel panel-clinic">

		<div class="panel-heading collapsed" href="#form_punch" data-toggle="collapse">

			<div class="arrow-down"></div>

			<h2 class="panel-title">Ta manuellt klipp för massören</h2>

		</div>

		<div id="form_punch" class="panel-collapse collapse">

			<div class="panel-body">

				<div class="alert alert-success" v-if="success != null">
					Kunden har nu {{ response.message }} klipp kvar
				</div>

				<div class="alert alert-warning" v-if="error != null">
					{{ error }}

					<span v-if="codes.length > 0">Följande koder finns för detta kort.</span>
					<div v-for="code in codes">
						<input type="radio" v-if="code.punched == 1" v-bind:checked="code.punched == 1" v-bind:disabled="code.punched == 1"  />

						<input type="radio" v-if="code.punched == 0" v-model="inputCode" v-bind:value="code.code"  />

						{{ code.code }}



					</div>

				</div>

				<b>Ange engångskod:</b>
				<input type="text" v-model="inputCode" class="form-control" placeholder="Kod" />

				<br>
				<b>Behandlingsdatum:</b>
				<datepicker
					language="sv"
					input-class="form-control"
					v-on:selected="selectDate"
					:format="date_format"
					:value="date_init">
				</datepicker>

				<br>
				<b>Välj konto:</b>
				<select v-model="account_id" class="form-control">
					<option value="m">3012</option>
					<option value="f">3011</option>
				</select>


				<button v-on:click="submit('validate')" type="submit" class="btn btn-default" style="margin-top:20px;">
					Skicka
				</button>


			</div>

		</div>

	</div>

</div>
</template>


<script>

	import mixin from './mixin'

    export default {

    	mixins: [mixin],

	    data() {

      		return {

      			inputCode: null,
                account_id: 'm',
                date_format: 'yyyy-MM-dd',
                date_init: new Date(),
                date_selected: moment(this.date_init).format('YYYY-MM-DD'),
                checkedCode: null,
                response: {},
                error: null,
                success: null,
                codes: {}

      		}

	    },

	    methods: {


	    	selectDate(date) {

	    		this.date_selected = date;

	    	},

	    	submit: function(mode) {

	    		var self = this;

	    		self.$http.post('/clinics/manualPunch', {

	    			clinic_id: self.clinic.id,
	    			code: self.inputCode,
	    			account_id: self.account_id,
	    			mode: mode,
	    			treatment_date: self.date_selected

	    		}).then((response) => {

                   console.log(response.body);

                   if(mode == 'validate') {

						if(response.body['error'] == false) {

							self.error = null;
							$("#punchModal").modal();

						} else {

							if(response.body['message'] == 'notFound') {
								self.error = 'Ogiltig kod.';
							}
							if(response.body['message'] == 'isUsed') {
								self.error = 'Koden är redan använd.';

								self.codes = response.body.codes;

							}
							if(response.body['message'] == 'expiredCard') {
								self.error = 'Klippkortet är inte längre giltigt.';
							}
							if(response.body['message'] == 'noClinicPrice') {
								self.error = 'Massören saknar ersättningsbelopp.';
							}

							self.success = null;
						}

					}

					if(mode == 'confirm') {

						if(response.body['error'] == false) {

							self.error = null;
							self.success = true;
							self.inputCode = null;

							$("#punchModal").modal('hide');

						}
					}


                   self.response = response.body;

                   //bus.$emit('refresh-data', 1)


                }, (response) => {
                    console.log(JSON.stringify(response));
                });

	    	}


	    }

	}

</script>
